import Vue from 'vue';

Vue.component('team-search-component', {
    props: [
        'userList',
        'teamSearch',
    ],

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            teamMember: null,
            teamMemberId: 0,
            userSearch: '',
            userResults: [],
            teamMemberFound: false,
        };
    },

    watch: {

        /**
         * Update teamMemberId when teamMember changes.
         */
        teamMember(value) {
            if (value) {
                console.log('TEAMMEMBER: ', value);
                this.teamMemberId = value ? value.id : 0;
            }
        },

        /**
         * Reset search UI upon untoggle (but keep the selected team member).
         * 
         * @param {Boolean} value 
         */
        teamSearch(value) {
            if (!value) {
                this.userSearch = '';
                // Don't reset teamMember or teamMemberId - keep the selection
            }
        },

        /**
         * Search the users list.
         * 
         * @param {String} value 
         */
        userSearch(value) {

            this.teamMemberFound = false;
            // Clear current results.
            this.userResults = [];

            // Don't search for empty strings.
            if (!value) {
                return;
            }

            // Clear found member if searching again.
            this.teamMember = null;

            // Split term on space and make it lowercase for checking.
            const terms = value.toLowerCase().split(' ');

            // Loop user list to test against search terms & add to results.
            for (let user in this.userList) {
                let testValue = this.userList[user].name.toLowerCase();
                let foundCount = 0;
                for (let term in terms) {
                    if (testValue.indexOf(terms[term]) > -1) {
                        foundCount++;
                    }
                }
                if (foundCount === terms.length) {
                    this.userResults.push(this.userList[user]);
                }
            }
        },
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        
        /**
         * Set given user as the resulting team member.
         * 
         * @param {Integer} usersResultIndex 
         */
        setTeamMember(usersResultIndex) {

            console.log('setTeamMember usersResultIndex: ', usersResultIndex);
            

            // Ignore out of bounds.
            if (usersResultIndex >= this.userResults.length) {
                return;
            }

            // Set team member & reset search field.
            this.teamMember = this.userResults[usersResultIndex];
            this.userSearch = this.teamMember.name;

            Vue.nextTick(() => {
                console.log('Teammember found');
                
                this.teamMemberFound = true;
            })
        },

        /**
         * Check for enter press to submit top result.
         * 
         * @param {Event} evt 
         */
        selectOnEnter(evt) {
            if (evt.key === 'Enter') {
                this.setTeamMember(0);
            }
        },
    },
});
